import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Image = ({ fileReference, alt, displayPopupTitle, title, lazyEnabled, widths, areas, link }) => {
  useEffect(() => {
    /**
     * This will let the `IntersectionObserver` API know that a new react
     * image is in placeand that it should be lazy loaded. @see lazyLoad.js
     */
    window.dispatchEvent(new CustomEvent('reactpicturemounted'));
  }, []);

  const renderPicture = () => (
    <picture className='lazy-load'>
      <source data-srcset={`${fileReference}?imwidth=480`} media='(max-width: 480px)' />
      <source data-srcset={`${fileReference}?imwidth=1024`} media='(min-width: 480px) and (max-width: 1024px)' />
      <source data-srcset={fileReference} media='(min-width: 1024px)' />
      <img data-src={fileReference} alt={alt} title={displayPopupTitle && title} />
    </picture>
  );

  const renderNoScript = () => {
    const renderNoScriptWrapper = !lazyEnabled && widths && widths.length <= 1 && !areas;
    return (
      <>
        {renderNoScriptWrapper && <noscript data-cmp-hook-image='noscript'>{renderPicture()}</noscript>}
        {!renderNoScriptWrapper && renderPicture()}
      </>
    );
  };

  const renderMainComp = () => {
    const renderTitle = displayPopupTitle && title;
    return (
      <>
        {link && (
          <a className='cmp-image__link' href={link} data-cmp-hook-image='link'>
            {renderNoScript()}
          </a>
        )}
        {!link && renderNoScript()}
        {!renderTitle && (
          <span className='cmp-image__title' itemProp='caption'>
            {title}
          </span>
        )}
        {renderTitle && <meta itemProp='caption' content={title} />}
      </>
    );
  };

  const renderTitle = displayPopupTitle && title;

  if (renderTitle) {
    return (
      <div itemScope itemType='http://schema.org/ImageObject'>
        {renderMainComp()}
      </div>
    );
  }
  return renderMainComp();
};

Image.propTypes = {
  link: PropTypes.string,
  lazyEnabled: PropTypes.bool,
  fileReference: PropTypes.isRequired,
  title: PropTypes.title,
  displayPopupTitle: PropTypes.string,
  alt: PropTypes.string,
};

export default Image;
